/**
 * Adds an 's' to the end of a string if the condition is truthy.
 * @param {string} string
 * @param {boolean} condition
 */
export const pluralize = (string, condition) => {
	return condition
		? `${string}s`
		: string;
};
